import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditStockModuleContext from 'contexts/EditStockModuleContext';
import { getStockWarehouse } from 'services/stockWarehouseServices';
import { StockWarehouse } from 'types/models/StockReceipt';
import StockWarehouseForm from 'forms/StockWarehouseForm';

export default (): JSX.Element => {
  const { t } = useTranslation();
  const history = useHistory();
  const { selectedWarehouse } = React.useContext(EditStockModuleContext);
  const [completeStockWarehouse, setCompleteStockWarehouse] = React.useState<StockWarehouse | null>(null);

  React.useEffect(() => {
    if (!selectedWarehouse) {
      history.replace('/private/stock/warehouses');
      return;
    }

    let mounted = true;

    (async () => {
      const completeData = await getStockWarehouse(selectedWarehouse.id);

      if (!mounted) return;

      if (!completeData) {
        history.replace('/private/stock/warehouses');
        return;
      }

      setCompleteStockWarehouse(completeData);
    })();

    return () => {
      mounted = false;
    };
  }, [selectedWarehouse, history]);

  if (!selectedWarehouse) return <></>;
  if (!completeStockWarehouse) return <div>{t('loading')}</div>;

  return <StockWarehouseForm warehouse={completeStockWarehouse} />;
};
